const UNKNOWN_WORD_INGREDIENT_KEYWORD_MATCH_TYPE = {
  SYNONYMS: {
    value: 'SYNONYMS',
    label: 'synonym',
  },
  VARIETIES: {
    value: 'VARIETIES',
    label: 'variety',
  },
}

export default UNKNOWN_WORD_INGREDIENT_KEYWORD_MATCH_TYPE
